<template>
  <transition>
    <div id="itembank">
      <!-- begin breadcrumb -->
      <ol class="breadcrumb pull-right">
        <li><router-link :to="{ path: '/' }">Home</router-link></li>
        <li>Preview & Setting</li>
        <!-- <li class="active">{{ mapel }}</li> -->
      </ol>
      <!-- end breadcrumb -->
      <!-- begin page-header -->
      <h1 class="page-header">Preview</h1>
      <!-- end page-header -->
      <div class="row">
        <div class="col-md-12">
          <!-- begin panel -->
          <div class="panel panel-inverse">
            <div class="panel-heading">
              <div class="btn-group pull-right">
                <button
                  class="btn btn-primary btn-xs btn-edit"
                  style="margin-left: 15px"
                  @click="saveSort()"
                >
                  Simpan Perubahan
                </button>
              </div>
              <h4 class="panel-title">Preview Konten</h4>
            </div>
            <div class="panel-body">
              <!-- <div class="hasfilterstatus">
              <div class="flex-disp">
                <div class="flex-disp" @click="modeTab = 'section'">
                  <div
                    :id="
                      modeTab === 'section' ? 'tabstatus-active' : 'tabstatus'
                    "
                  >
                    Preview Content Section &
                  </div>
                  <div
                    :id="
                      modeTab === 'section'
                        ? 'tabtriangle-active'
                        : 'tabtriangle'
                    "
                  ></div>
                </div>
                <div class="flex-disp" @click="modeTab = 'menu'">
                  <div
                    :id="modeTab === 'menu' ? 'tabstatus-active' : 'tabstatus'"
                  >
                    Preview Menu
                  </div>
                  <div
                    :id="
                      modeTab === 'menu' ? 'tabtriangle-active' : 'tabtriangle'
                    "
                  ></div>
                </div>
              </div>
            </div> -->
            </div>

            <div>
              <div class="preview-content">
                <!-- ========= LIST SECTION UNPUBLISHED ================== -->
                <div class="listdrag">
                  <span class="titleSection">List Section</span>
                  <draggable
                    v-model="sectionList"
                    v-bind="dragOptions"
                    :move="onMove"
                    id="dragAreaSectionContent"
                  >
                    <transition-group id="transGroupSection">
                      <div v-for="element in sectionList" :key="element.id">
                        <div class="dragItem">
                          <i
                            v-if="element.type === 'VIDEO'"
                            class="fa fa-play"
                            id="iconItem"
                          ></i>
                          <i
                            v-if="element.type === 'SINGLE_BANNER'"
                            class="fa fa-picture-o"
                            id="iconItem"
                          ></i>
                          <i
                            v-if="element.type === 'MULTIPLE_BANNER'"
                            class="fa fa-clone"
                            id="iconItem"
                          ></i>
                          <i
                            v-if="element.type === 'EXERCISE'"
                            class="fa fa-pencil-square-o"
                            id="iconItem"
                          ></i>
                          <i
                            v-if="element.type === 'ARTICLE'"
                            class="fa fa-newspaper-o"
                            id="iconItem"
                          ></i>
                          <i
                            v-if="element.type === 'TRYOUT_RESULT'"
                            class="fa fa-check-square-o"
                            id="iconItem"
                          ></i>
                          <i
                            v-if="element.type === 'ONGOING_TRYOUT'"
                            class="fa fa-clock-o"
                            id="iconItem"
                          ></i>
                          <div>
                            {{ element.name }}<br />
                            {{ element.type }}
                          </div>
                        </div>
                      </div>
                    </transition-group>
                  </draggable>
                </div>

                <!-- PHONE PREVIEW SECTION -->
                <div
                  class="phone"
                  v-bind:style="{ backgroundImage: 'url(' + logo + ')' }"
                  id="phoneArea"
                >
                  <div v-on:click="menuMode = true" class="menu" id="menuDrag">
                    <div class="menuRow">
                      <div
                        class="menuIteration"
                        v-for="element in submitMenu.slice(0, 4)"
                        :key="element.id"
                      >
                        <img :src="element.picture" class="iconMenu" />
                        <div class="captionMenu">
                          {{ element.display_name }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="!menuMode" class="listdragPhoneArea">
                    <div class="dumHeader">
                      <div class="dumWrapper">
                        <div class="centerFlex">
                          <img :src="ticket" class="ticketIcon" />
                          <div class="ticketCount">
                            <span class="ticketInteger"><b>315</b></span>
                            <p class="dumSeeMore">lihat detail ></p>
                          </div>
                        </div>
                        <div class="centerFlex">
                          <div class="ticketCount">
                            <span class="haiFulan"><b>Hai Fulan,</b></span>
                            <p class="gradeCapt">Kelas 12</p>
                          </div>
                          <img :src="pp" class="imagePP" />
                        </div>
                      </div>
                    </div>
                    <div class="package-list">
                      <div class="alertTicket">
                        <span
                          >Kamu punya
                          <b style="color: #355eab">100 Paket Belajar</b></span
                        >
                        <i
                          class="fa fa-chevron-right"
                          style="color: #3cb54a"
                        ></i>
                      </div>
                    </div>
                    <draggable
                      v-model="submitList"
                      v-bind="dragOptions"
                      v-on:add="onSectionAdd($event)"
                      v-on:remove="onSectionRemove($event)"
                      :move="onMove"
                      class="draggable-1"
                      id="dragAreaSection"
                    >
                      <transition-group id="transAreaSection">
                        <div
                          v-for="element in submitList"
                          :key="element.id"
                          class="draggable-3"
                        >
                          <div
                            v-if="element.type === 'SINGLE_BANNER'"
                            class="banner"
                          >
                            <div class="nameSingleBanner">
                              <b>{{ element.name }}</b>
                            </div>
                            <div>
                              <img
                                :src="
                                  element.details[0].content | parsingContentIMG
                                "
                                class="imgSingleBanner"
                              />
                              <!-- {{JSON.parse(element.details[0].content).image_url }} -->
                            </div>
                          </div>

                          <div
                            v-if="element.type === 'MULTIPLE_BANNER'"
                            class="banner"
                          >
                            <div class="nameMultiBanner">
                              <b>{{ element.name }}</b>
                            </div>
                            <div style="width: 5000px">
                              <div
                                v-for="(item, index) in element.details"
                                v-bind:key="index"
                                class="fl"
                              >
                                <img
                                  :src="item.content | parsingContentIMG"
                                  class="imgMultiBanner"
                                />
                              </div>
                            </div>
                          </div>

                          <div
                            v-if="element.type === 'ARTICLE'"
                            class="articleItem"
                          >
                            <div class="nameArticle">
                              <b>{{ element.name }}</b>
                            </div>
                            <div style="width: 5000px">
                              <div
                                v-for="(item, index) in element.details"
                                v-bind:key="index"
                                class="articleIteration"
                              >
                                <div class="articleWrapper">
                                  <img
                                    :src="item.content | parsingContentIMG"
                                    class="imgArticle"
                                  />
                                  <div class="articleText">
                                    <p class="articleTitle">
                                      {{ item.content | parsingTITLE }}
                                    </p>
                                    <p>
                                      {{ item.content | parsingDESCRIPTION }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            v-if="element.type === 'VIDEO'"
                            class="videoItem"
                          >
                            <div class="nameVideo">
                              <b>{{ element.name }}</b>
                            </div>
                            <div style="width: 5000px">
                              <div
                                class="videoIteration"
                                v-for="(item, index) in element.details"
                                v-bind:key="index"
                              >
                                <div class="videoWrapper">
                                  <div
                                    class="videoThumbnail"
                                    :style="{
                                      backgroundImage: 'url(' + play + ')',
                                      height: '100px',
                                      width: '100px',
                                      backgroundRepeat: 'no-repeat',
                                      zIndex: 1,
                                      left: '45%',
                                      top: '15%',
                                      position: 'absolute',
                                    }"
                                  ></div>
                                  <img
                                    class="imgVideo"
                                    :src="item.content | parsingThumbnail"
                                  />
                                  <div class="videoText">
                                    <p class="videoTItle">
                                      {{ item.content | parsingTITLE }}
                                    </p>
                                    <p>
                                      {{ item.content | parsingDESCRIPTION }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            v-if="element.type === 'ONGOING_TRYOUT'"
                            class="onTryoutItem"
                          >
                            <div class="onTryoutWrapper" style="">
                              <b>{{ element.name }}</b>
                            </div>
                            <div style="width: 5000px">
                              <div
                                class="onTryoutIteration"
                                v-for="(item, index) in element.details"
                                v-bind:key="index"
                              >
                                <div class="onTryoutText">
                                  <p class="onTryoutType" style="">
                                    {{ item.content | parsingTOType }}
                                  </p>
                                  <p class="onTryoutName">
                                    {{ item.content | parsingTOName }}
                                  </p>
                                  <p>
                                    <i class="fa fa-calendar"></i> &nbsp;{{
                                      item.content | parsingTOTime
                                    }}
                                  </p>
                                  <p class="seeMoreOnTryout">Lihat Detail</p>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            v-if="element.type === 'TRYOUT_RESULT'"
                            class="resultItem"
                          >
                            <div class="resultWrapper">
                              <b>{{ element.name }}</b>
                            </div>
                            <div style="width: 5000px">
                              <div
                                class="resultIteration"
                                v-for="(item, index) in element.details"
                                v-bind:key="index"
                              >
                                <div class="resultText">
                                  <p class="resultType">
                                    {{ item.content | parsingTOType }}
                                  </p>
                                  <p class="resultName">
                                    {{ item.content | parsingTOName }}
                                  </p>
                                  <p>
                                    <i class="fa fa-calendar"></i> &nbsp;{{
                                      item.content | parsingTOTime
                                    }}
                                  </p>
                                  <p class="resultSeeMore">Lihat Hasil</p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            v-if="element.type === 'EXERCISE'"
                            class="exerciseItem"
                          >
                            <div class="exerciseName" style="">
                              <b>{{ element.name }}</b>
                              <button class="exerciseIPA">IPA</button>
                              <button class="exerciseIPS">IPS</button>
                            </div>
                            <div
                              class="cardExerciseIteration"
                              v-for="(item, index) in element.details.slice(
                                0,
                                1
                              )"
                              v-bind:key="index"
                            >
                              <div class="exerciseContent">
                                <p class="exerciseMapel">{{ mapelExercise }}</p>
                                <div v-html="changeFormat(item.content)"></div>
                                <p class="exerciseButtonYuk">
                                  Kerjakan Soal Yuk
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </transition-group>
                    </draggable>
                  </div>

                  <!-- ======================== MENU LAYOUT DRAG DROP =============================================================== -->
                  <div v-if="menuMode" class="listdragMenu">
                    <div>
                      <div class="overlay"></div>
                      <div class="dumHeader">
                        <div class="dumWrapper">
                          <div class="centerFlex">
                            <img :src="ticket" class="ticketIcon" />
                            <div class="ticketCount">
                              <span class="ticketInteger"><b>315</b></span>
                              <p class="dumSeeMore">lihat detail ></p>
                            </div>
                          </div>
                          <div class="centerFlex">
                            <div class="ticketCount">
                              <span class="haiFulan"><b>Hai Fulan,</b></span>
                              <p class="gradeCapt">Kelas 12</p>
                            </div>
                            <img :src="pp" class="imagePP" />
                          </div>
                        </div>
                      </div>
                      <div class="package-list">
                        <div class="alertTicket">
                          <span
                            >Kamu punya
                            <b style="color: #355eab"
                              >100 Paket Belajar</b
                            ></span
                          >
                          <i
                            class="fa fa-chevron-right"
                            style="color: #3cb54a"
                          ></i>
                        </div>
                      </div>
                      <div class="dragmenuarea" id="dragMenuSubmit">
                        <div class="icDragMenu" v-on:click="menuMode = false">
                          <i
                            class="fa fa-chevron-down"
                            style="color: #3cb54a"
                          ></i>
                        </div>
                        <draggable
                          v-model="submitMenu"
                          v-bind="dragOptionsMenu"
                          v-on:add="onMenuAdd($event)"
                          v-on:remove="onMenuRemove($event)"
                          :move="onMove"
                          class="draggableMenuSubmit"
                        >
                          <transition-group class="transDragmenu">
                            <div
                              v-for="element in submitMenu"
                              :key="element.id"
                            >
                              <div class="menuPreviewWrapper">
                                <img
                                  :src="element.picture"
                                  class="imgMenuPreview"
                                />
                                <div class="menuPreviewText">
                                  <p class="menuPreviewName">
                                    {{ element.name }}
                                  </p>
                                  <span style="font-size: 11px">{{
                                    element.description
                                  }}</span>
                                </div>
                              </div>
                            </div>
                          </transition-group>
                        </draggable>
                      </div>
                    </div>
                  </div>
                </div>

                <!--  ================== LIST MENU UNPUBLISHED ======================= -->
                <div class="listdragMenuSection" style="">
                  <span class="listmenuCapt">List Menu</span>
                  <draggable
                    id="draggableMenuSection"
                    v-model="menuList"
                    v-bind="dragOptionsMenu"
                    :move="onMove"
                  >
                    <transition-group class="transgrouplistdragmenusection">
                      <div v-for="element in menuList" :key="element.id">
                        <div class="menuSectionWrapper">
                          <img :src="element.picture" class="imgMenuSection" />
                          <div class="menuSectionText">
                            <p class="menuSectionName">{{ element.name }}</p>
                            <span>{{ element.description }}</span>
                          </div>
                        </div>
                      </div>
                    </transition-group>
                  </draggable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<style>
.preview-content {
  display: flex;
}

.listdrag {
  padding: 10px;
  padding-top: 20px;
}

.titleSection {
  font-size: 20px;
  font-weight: bold;
}

#dragAreaSectionContent {
  max-height: 550px;
  overflow: auto;
  overflow-x: hidden;
  width: 242px;
  display: flex;
  min-height: 200px;
  border: 1px lightgray solid;
  margin-right: 10px;
}

#transGroupSection {
  width: 100%;
  min-height: 40px;
}

.dragItem {
  min-width: 150px;
  min-height: 60px;
  border: solid 1px lightgray;
  margin: 5px;
  border-radius: 5px;
  cursor: grab;
  display: flex;
  align-items: center;
  padding: 10px;
}

#iconItem {
  font-size: 25px;
  margin-right: 10px;
}

#phoneArea {
  padding: 10px;
  padding-top: 55px;
  background-position: center;
  background-size: cover;
  height: 600px;
  width: 600px;
}

#menuDrag {
  z-index: 1;
  cursor: pointer;
  background-color: white;
  width: 235px;
  bottom: 60px;
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  border-radius: 100px;
  border: 1px solid lightgrey;
}

.menuRow {
  position: relative;
  display: flex;
  flex-flow: row;
}

.menuIteration {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 7px;
  padding-left: 10px;
  width: 70px;
}

.iconMenu {
  width: 35px;
  height: 35px;
}

.captionMenu {
  width: 100%;
  text-align: center;
  font-size: 7px;
}
.listdragPhoneArea {
  width: 245px;
  margin: 0 auto;
  max-height: 500px;
  overflow: auto;
  overflow-x: hidden;
  padding-right: 5px;
  z-index: 0;
  padding-bottom: 50px;
}

.dumHeader {
  display: flex;
}

.dumWrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.centerFlex {
  display: flex;
  align-items: center;
}

.ticketIcon {
  width: 25px;
  margin-right: 4px;
}

.ticketCount {
  display: flex;
  flex-flow: column;
  padding-top: 20px;
}

.ticketInteger {
  color: #355eab;
  font-weight: 400;
}

.dumSeeMore {
  color: #355eab;
  font-size: 11px;
}

.haiFulan {
  color: black;
  font-weight: 400;
}

.gradeCapt {
  color: #355eab;
  font-size: 11px;
  text-align: right;
}

.imagePP {
  width: 25px;
  margin-left: 10px;
}

.alertTicket {
  border-radius: 6px;
  background-color: rgb(226, 255, 230);
  height: 30px;
  width: 230px;
  margin: 0 auto;
  padding: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#dragAreaSection {
  width: 100%;
  min-height: 400px;
  max-height: 400px;
  display: flex;
}

#transAreaSection {
  width: 100%;
  min-height: 40px;
  padding-bottom: 50px;
}

.draggable-3 {
  padding-top: 10px;
}

.banner {
  padding: 5px;
  margin-top: 10px;
}

.nameSingleBanner {
  font-size: 14px;
  line-height: 40px;
}

.imgSingleBanner {
  width: 100%;
  height: 100px;
  border-radius: 10px;
}

.nameMultiBanner {
  font-size: 14px;
  line-height: 40px;
}

.fl {
  float: left;
}

.imgMultiBanner {
  max-width: 250px;
  min-width: 200px;
  margin-right: 10px;
  height: 100px;
  border-radius: 10px;
}

.articleItem {
  padding: 5px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.nameArticle {
  font-size: 14px;
  line-height: 40px;
}

.articleIteration {
  float: left;
  margin-bottom: 10px;
}

.articleWrapper {
  max-width: 200px;
  height: 220px;
  border: solid 1px lightgray;
  margin-right: 10px;
  border-radius: 10px;
  box-shadow: 0px 0px 3px 1px lightgrey;
}

.imgArticle {
  width: 200px;
  height: 100px;
  border-radius: 10px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}

.articleText {
  padding: 5px;
  padding-left: 10px;
}

.articleTitle {
  font-size: 13px;
  font-weight: 600;
  margin-top: 5px;
  word-break: break-all;
  margin-bottom: 2px;
}

.videoItem {
  padding: 5px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.nameVideo {
  font-size: 14px;
  line-height: 40px;
}

.videoIteration {
  float: left;
  margin-bottom: 10px;
}

.videoWrapper {
  max-width: 200px;
  height: 220px;
  border: solid 1px lightgray;
  margin-right: 10px;
  border-radius: 10px;
  box-shadow: 0px 0px 3px 1px lightgrey;
  position: relative;
}


.imgVideo {
  width: 200px;
  height: 100px;
  border-radius: 10px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}

.videoText {
  padding: 5px;
  padding-left: 10px;
}

.videoTitle {
  font-size: 13px;
  font-weight: 600;
  margin-top: 5px;
  word-break: break-all;
  margin-bottom: 2px;
}

.onTryoutItem {
  padding: 5px;
  margin-top: 10px;
}

.onTryoutWrapper {
  font-size: 14px;
  line-height: 40px;
}

.onTryoutIteration {
  float: left;
}

.onTryoutText {
  background: #ffffff;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  width: 100%;
  max-width: 210px;
  width: 210px;
  padding: 10px;
  padding-bottom: 1px;
  padding-top: 15px;
  margin-right: 10px;
}

.onTryoutType {
  font-size: 14px;
  font-weight: bold;
  color: #355eab;
}

.onTryoutName {
  font-size: 18px;
  font-weight: 700;
  color: black;
  margin: 0;
}

.seeMoreOnTryout {
  font-size: 14px;
  font-weight: bold;
  color: #355eab;
  text-align: center;
}

.resultSeeMore {
  font-size: 14px;
  font-weight: bold;
  color: #355eab;
  text-align: center;
}

.resultName {
  font-size: 18px;
  font-weight: 700;
  color: black;
  margin: 0;
}

.resultType {
  font-size: 14px;
  font-weight: bold;
  color: #355eab;
}

.resultText {
  background: #e2ffe6;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  width: 100%;
  max-width: 225px;
  width: 225px;
  padding: 10px;
  padding-bottom: 1px;
  padding-top: 15px;
  margin-right: 10px;
}

.resultIteration {
  float: left;
}

.resultWrapper {
  font-size: 14px;
  line-height: 40px;
  margin: 0;
}

.resultItem {
  padding: 5px;
  margin-top: 10px;
}

.cardExerciseIteration {
  float: left;
  margin-top: 10px;
  z-index: 0;
}

.exerciseContent {
  background: #ffffff;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  width: 100%;
  max-width: 225px;
  width: 225px;
  padding: 10px;
  padding-bottom: 1px;
}
.exerciseButtonYuk {
  font-size: 14px;
  font-weight: bold;
  color: #355eab;
  text-align: center;
}

.exerciseMapel {
  font-size: 14px;
  font-weight: bold;
  color: #355eab;
  margin: 0;
}

.exerciseName {
  font-size: 14px;
}

.exerciseIPA {
  background-color: #cbf3ff;
  border-radius: 10px;
  color: #00ade2;
  border: none;
  padding: 5px;
  padding-left: 10px;
  padding-right: 10px;
}

.exerciseItem {
  padding: 5px;
  margin-top: 10px;
}

.exerciseIPS {
  background-color: #f4f4f4;
  border-radius: 10px;
  color: #979797;
  border: none;
  padding: 5px;
  padding-left: 10px;
  padding-right: 10px;
}

.listdragMenu {
  width: 245px;
  margin: 0 auto;
  max-height: 500px;
  overflow: auto;
  overflow-x: hidden;
  padding-right: 5px;
  z-index: 3;
}

.overlay {
  height: 531px;
  position: absolute;
  width: 245px;
  opacity: 0.5;
  background-color: black;
  margin-top: -20px;
}

#dragMenuSubmit {
  z-index: 3;
  height: 400px;
  max-height: 400px;
  overflow: auto;
  overflow-x: hidden;
  width: 245px;
  position: absolute;
  margin-top: 10px;
  background-color: white;
  border-radius: 10px;
  padding-top: 10px;
}

.icDragMenu {
  width: 100%;
  text-align: center;
  cursor: pointer;
}

.draggableMenuSubmit {
  width: 250px;
  display: flex;
  min-height: 200px;
}

.transDragMenu {
  width: 100%;
  min-height: 40px;
}

.menuPreviewWrapper {
  min-width: 150px;
  min-height: 60px;
  margin: 5px;
  border-radius: 5px;
  display: flex;
  justify-content: flex-start;
  cursor: grab;
  padding: 10px;
}

.imgMenuPreview {
  width: 35px;
  height: 35px;
}

.menuPreviewText {
  display: flex;
  flex-flow: column;
  /* align-items;center; */
}

.menuPreviewName {
  margin: 0px;
  font-size: 12px;
  font-weight: bold;
}

.listdragMenuSection {
  padding: 10px;
  padding-top: 20px;
}

.listmenuCapt {
  font-size: 20px;
  font-weight: bold;
}

.transgrouplistdragmenusection {
  width: 100%;
  min-height: 40px;
}

.menuSectionWrapper {
  min-width: 150px;
  min-height: 60px;
  border: solid 1px lightgray;
  margin: 5px;
  border-radius: 5px;
  display: flex;
  justify-content: flex-start;
  cursor: grab;
  padding: 10px;
}

.imgMenuSection {
  width: 50px;
  height: 50px;
}

.menuSectionText {
  display: flex;
  flex-flow: column;
  /* align-items;center;  */
  margin-left: 10px;
}

.menuSectionName {
  margin: 0px;
  font-size: 13px;
  font-weight: bold;
}

#draggableMenuSection {
  width: 250px;
  display: flex;
  min-height: 200px;
  border: 1px lightgray solid;
}

.flex-disp {
  display: flex;
}

.hasfilterstatus {
  float: left;
  margin-top: 20px;
  width: 100%;
  border-bottom: 1px solid lightgrey;
}

#tabstatus {
  background: white;
  height: 35px;
  align-items: center;
  display: flex;
  padding: 10px;
  min-width: 60px;
  justify-content: center;
  cursor: pointer;
}
#tabtriangle {
  width: 0;
  height: 0;
  border-bottom: 35px solid white;
  border-right: 25px solid transparent;
  cursor: pointer;
}
#tabstatus-active {
  background: lightgray;
  height: 35px;
  align-items: center;
  display: flex;
  padding: 10px;
  min-width: 60px;
  justify-content: center;
  color: #348fe2;
  border-top-left-radius: 5px;
  cursor: pointer;
}
#tabtriangle-active {
  width: 0;
  height: 0;
  border-bottom: 35px solid lightgrey;
  color: #348fe2;
  border-right: 25px solid transparent;
  cursor: pointer;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

/* SCROLLBAR ANIMATION */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px lightgray;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: gray;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: black;
}
</style>
<script>
import ContentService from "@/services/content.js";
import DataTable from "@/components/plugins/DataTable";
import moment from "moment";
import logo from "@/assets/img/phone_frame.png";
import noImage from "@/assets/img/no-image.png";
import playBTN from "@/assets/img/playbtn.png";
import ticket from "@/assets/img/previewsetting/ticket.svg";
import pp from "@/assets/img/previewsetting/pp.svg";
import draggable from "vuedraggable";
import Marked from "marked";

export default {
  name: "itembank",
  components: {
    draggable,
    "app-datatable": DataTable,
  },
  data: function () {
    return {
      menuMode: false,
      logo: logo,
      ticket: ticket,
      pp: pp,
      noimg: noImage,
      play: playBTN,
      mapel: "",
      headers: ["Nama", "Judul", "Tampilkan", "Status"],
      items: [],
      selectedItem: null,
      maxPage: 0,
      currentPage: 1,
      query: "",
      field: "",
      disableStatus: null,
      modeTab: "section",
      mapelExercise: null,
      params: {
        status: null,
      },
      sectionList: [
        {
          id: 1,
          name: "Loading data...",
        },
      ],
      submitList: [],
      menuList: [
        {
          id: 1,
          name: "Loading data...",
        },
      ],
      submitMenu: [],
    };
  },
  watch: {
    $route: function (to, from) {
      alert("asdfsadf");
      console.log(to);
    },
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "section",
        disabled: false,
        ghostClass: "ghost",
      };
    },
    dragOptionsMenu() {
      return {
        animation: 0,
        group: "menu",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  filters: {
    parsingContentIMG(val) {
      var a = JSON.parse(val);
      return a.image_url;
    },
    parsingTITLE(val) {
      var a = JSON.parse(val);
      var b = a.title.length > 50 ? a.title.substr(0, 50) + "..." : a.title;
      if (a.title === "" || a.title === null) return "null";
      else return b;
    },
    parsingDESCRIPTION(val) {
      var a = JSON.parse(val);
      var b =
        a.description.length > 70
          ? a.description.substr(0, 70) + "..."
          : a.description;
      if (a.description === "" || a.description === null) return "null";
      else return b;
    },
    parsingTOType(val) {
      var a = JSON.parse(val);
      var b = a.type;
      return b;
    },
    parsingTOName(val) {
      var a = JSON.parse(val);
      var b = a.name;
      return b;
    },
    parsingTOTime(val) {
      var a = JSON.parse(val);
      var b =
        moment(a.opened_at).format("DD MMMM") +
        " " +
        moment(a.closed_at).format("DD MMMM");
      return b;
    },
    parsingThumbnail(val) {
      var a = JSON.parse(val);
      var b = null;
      if (a.thumbnail !== "" || a.thumbnail !== null) {
        b = a.thumbnail;
      } else {
        b =
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/No_image_available_600_x_400.svg/1024px-No_image_available_600_x_400.svg.png";
      }
      return b;
    },
  },
  methods: {
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;

      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
    onMenuAdd: function(event) {
      var newIndex = event.newDraggableIndex
      var menu = this.submitMenu[newIndex]
      ContentService.togglePublishMenu(menu.id, function(response) {
        if(!response.success) alert("Terjadi kesalahan: " + response.message)
      })
    },
    onMenuRemove: function(event) {
      var newIndex = event.newDraggableIndex
      var oldIndex = event.oldDraggableIndex
      var menu = this.menuList[newIndex];

      if(!menu.is_removable) {
        this.menuList.splice(newIndex, 1)
        this.submitMenu.splice(oldIndex, 0, menu)
        alert("Menu " + menu.display_name + " tidak dapat dinon-aktifkan")
      } else {
        ContentService.togglePublishMenu(menu.id, function(response) {
          if(!response.success) alert("Terjadi kesalahan: " + response.message)
        })
      }
    },
    onSectionAdd: function(event) {
      var newIndex = event.newDraggableIndex
      var section = this.submitList[newIndex]
      ContentService.togglePublishSection(section.id, function(response) {
        if(!response.success) alert("Terjadi kesalahan: " + response.message)
      })
    },
    onSectionRemove: function(event) {
      var newIndex = event.newDraggableIndex
      var oldIndex = event.oldDraggableIndex
      var section = this.sectionList[newIndex];
      console.log(section)

      if(!section.is_removable) {
        this.sectionList.splice(newIndex, 1)
        this.submitList.splice(oldIndex, 0, section)
        alert("Section " + section.name + " tidak dapat dinon-aktifkan")
      } else {
        ContentService.togglePublishSection(section.id, function(response) {
          if(!response.success) alert("Terjadi kesalahan: " + response.message)
        })
      }
    },
    loadData: function () {
      this.publishedLoad();
      this.hiddenLoad();
    },
    publishedLoad: function () {
      this.items = [];
      var context = this;
      this.params.status = "PUBLISHED";
      ContentService.getHomeContent(this.params, function (result) {
        if (result.success) {
          context.submitList = result.data;
          context.submitList.sort((a,b) => (a.order_number > b.order_number) ? 1 : -1)
        }
      });

      ContentService.getMenuPreview(this.params, function (result) {
        if (result.success) {
          context.submitMenu = result.data;
          context.submitMenu.sort((a,b) => (a.order_number > b.order_number) ? 1 : -1)
        }
      });
    },
    hiddenLoad: function () {
      this.items = [];
      var context = this;
      this.params.status = "HIDDEN";
      ContentService.getHomeContent(this.params, function (result) {
        if (result.success) {
          context.sectionList = result.data;
        }
      });
      ContentService.getMenuPreview(this.params, function (result) {
        if (result.success) {
          context.menuList = result.data;
        }
      });
    },
    changeFormat(isi) {
      try {
        var content = JSON.parse(isi);
        this.mapelExercise = content.mapel.nama;
        var text = this.compileInlineLatex(content.isi);
        text = this.compileBlockLatex(text);
        text = Marked(text, { sanitize: false });

        return text;
      } catch (e) {
        return "Error Parsing Soal";
      }
    },
    compileInlineLatex: function (content) {
      var pattern = /\\\\\((.*?)\\\\\)/g;
      var compiledContent = content;
      var match;
      while ((match = pattern.exec(compiledContent))) {
        var index = match.index;
        var length = match[0].length;
        var formula = katex.renderToString(match[1]);
        compiledContent =
          compiledContent.substr(0, index) +
          formula +
          compiledContent.substr(index + length);
      }

      return compiledContent;
    },
    compileBlockLatex: function (content) {
      var pattern = /\$\$(.*?)\$\$/g;
      var compiledContent = content;
      var match;
      while ((match = pattern.exec(compiledContent))) {
        var index = match.index;
        var length = match[0].length;
        var formula =
          '<p class="text-center">' + katex.renderToString(match[1]) + "</p>";
        compiledContent =
          compiledContent.substr(0, index) +
          formula +
          compiledContent.substr(index + length);
      }

      return compiledContent;
    },
    saveSort: function () {
      var section = this.submitList;
      var menu = this.submitMenu;

      var hidSection = this.sectionList;
      var hidMenu = this.menuList;

      var bodySection = [];
      var bodyMenu = [];
      for (var i = 0; i < section.length; i++) {
        bodySection.push({
          section_id: section[i].id,
          order_number: i + 1,
          status: "PUBLISHED",
        });
      }

      for (var i = 0; i < hidSection.length; i++) {
        bodySection.push({
          section_id: hidSection[i].id,
          order_number: i + 1,
          status: "HIDDEN",
        });
      }

      for (var i = 0; i < menu.length; i++) {
        bodyMenu.push({
          menu_id: menu[i].id,
          order_number: i + 1,
          status: "PUBLISHED",
        });
      }

      for (var i = 0; i < hidMenu.length; i++) {
        bodyMenu.push({
          menu_id: hidMenu[i].id,
          order_number: i + 1,
          status: "HIDDEN",
        });
      }

      var successR = 0;
      ContentService.updateMenuSort(bodyMenu, function (result) {
        if (result.success) {
          ContentService.updateSectionSort(bodySection, function (result) {
            if (result.success) {
              alert("Pengaturan Home dan Menu telah berhasil di simpan");
            }
          });
        }
      });
    },
  },
  mounted: function () {
    this.loadData();
  },
};
</script>



// WEBPACK FOOTER //
// Preview.vue?1d1aac46